{
  "auth": {
    "login": {
      "title": "Sign In",
      "noAccount": "Don't have an account?",
      "registerLink": "Sign Up",
      "forgotPassword": "Forgot password?",
      "submit": "SIGN IN",
      "email": {
        "label": "Email",
        "placeholder": "email@example.com"
      },
      "password": {
        "label": "Password",
        "placeholder": "Your password"
      }
    },
    "register": {
      "title": "Sign Up",
      "hasAccount": "Already have an account?",
      "loginLink": "Sign In",
      "submit": "Sign Up",
      "accountInfo": "Account Information",
      "baseInfo": "Basic Information",
      "residence": "Residence",
      "domicile": "Domicile",
      "private": "Private",
      "company": "Company",
      "domicileDifferent": "Domicile different from residence",
      "privacyConsent": "I consent to the processing of personal data under GDPR Privacy Law *",
      "dataConsent": "I consent to the processing of personal data *",
      "successMessage": "Registration successful. Please check your email to activate your account",
      "email": {
        "label": "Email",
        "placeholder": "email@example.com"
      },
      "emailConfirm": {
        "label": "Confirm Email",
        "placeholder": "email@example.com"
      },
      "password": {
        "label": "Password",
        "placeholder": "Your password"
      },
      "passwordConfirm": {
        "label": "Confirm Password",
        "placeholder": "Your password"
      },
      "firstName": {
        "label": "First Name",
        "placeholder": "Your first name"
      },
      "lastName": {
        "label": "Last Name",
        "placeholder": "Your last name"
      },
      "vatTaxNumber": {
        "labelCompany": "VAT Number",
        "labelPrivate": "Tax Code",
        "placeholderCompany": "VAT Number",
        "placeholderPrivate": "Tax Code",
        "description": "Required for residences in Italy"
      },
      "companyName": {
        "label": "Company Name",
        "placeholder": "Company name"
      },
      "gender": {
        "label": "Gender",
        "placeholder": "Gender",
        "male": "Male",
        "female": "Female"
      },
      "pec": {
        "label": "PEC",
        "placeholder": "PEC"
      },
      "sdi": {
        "label": "SDI",
        "placeholder": "SDI"
      },
      "phone": {
        "label": "Phone",
        "placeholder": "+39 123456789"
      },
      "height": {
        "label": "Height (cm)",
        "placeholder": "Height (cm)"
      },
      "birthDate": {
        "label": "Date of Birth",
        "placeholder": "Date of birth"
      },
      "birthCity": {
        "label": "City of Birth",
        "placeholder": "City of birth"
      },
      "nationality": {
        "label": "Nationality",
        "placeholder": "Nationality"
      },
      "country": {
        "label": "Country of Residence",
        "placeholder": "Country of residence"
      },
      "province": {
        "label": "Province of Residence",
        "placeholder": "Province of residence"
      },
      "city": {
        "label": "City",
        "placeholderResidence": "City of residence",
        "placeholderDomicile": "City of domicile"
      },
      "zip": {
        "label": "Postal Code",
        "placeholder": "Postal code"
      },
      "address": {
        "label": "Address",
        "placeholderResidence": "Residence address",
        "placeholderDomicile": "Domicile address"
      },
      "domicileCountry": {
        "placeholder": "Country of domicile"
      },
      "domicileProvince": {
        "placeholder": "Province of domicile"
      },
      "domicileCity": {
        "placeholder": "City of domicile"
      },
      "domicileZip": {
        "placeholder": "Postal code of domicile"
      },
      "validation": {
        "emailMismatch": "Emails do not match",
        "passwordMismatch": "Passwords do not match"
      }
    },
    "passwordReset": {
      "title": "Reset Password",
      "knowPassword": "Already know your password?",
      "loginLink": "Sign In",
      "enterNewPassword": "Enter a new password.",
      "newPassword": {
        "label": "New Password",
        "placeholder": "Your new password"
      },
      "passwordConfirm": {
        "label": "Confirm Password",
        "placeholder": "Your new password"
      },
      "submit": "Confirm",
      "invalidToken": "Password reset link is invalid or expired.",
      "requestNew": "Request a new one",
      "successMessage": "Password reset successfully",
      "validation": {
        "passwordMismatch": "Passwords do not match."
      }
    },
    "passwordResetRequest": {
      "title": "Reset Password",
      "knowPassword": "Already know your password?",
      "loginLink": "Sign In",
      "instructions": "Enter the email address you registered with and you will receive a link to reset your password.",
      "email": {
        "label": "Email",
        "placeholder": "email@example.com"
      },
      "submit": "RESET PASSWORD",
      "successMessage": "Check your email inbox for instructions on how to reset your password"
    },
    "activateAccount": {
      "title": "Complete Registration",
      "instructions": "Set your password to continue",
      "password": {
        "label": "Password",
        "placeholder": "Your password"
      },
      "passwordConfirm": {
        "label": "Confirm Password",
        "placeholder": "Your password"
      },
      "submit": "Confirm",
      "invalidToken": "Invalid or expired token",
      "verified": "Your account has been successfully verified",
      "validation": {
        "passwordMismatch": "Passwords do not match."
      }
    }
  },
  "home": {
    "welcome": "Welcome",
    "tabs": {
      "wishlist": "Wishlist",
      "bookings": "Bookings",
      "account": "Account",
      "editPassword": "Change Password"
    }
  },
  "account": {
    "title": "Account",
    "type": {
      "private": "Private",
      "company": "Company"
    },
    "logout": "Logout",
    "baseInfo": "Basic Information",
    "residence": "Residence",
    "domicile": "Domicile",
    "domicileDifferent": "Domicile different from residence",
    "update": "UPDATE",
    "successMessage": "Information updated successfully!",
    "loadError": "Error loading account",
    "fields": {
      "firstName": {
        "label": "First Name",
        "placeholder": "Your first name"
      },
      "lastName": {
        "label": "Last Name",
        "placeholder": "Your last name"
      },
      "vatTaxNumber": {
        "labelCompany": "VAT Number",
        "labelPrivate": "Tax Code",
        "placeholderCompany": "VAT Number",
        "placeholderPrivate": "Tax Code"
      },
      "companyName": {
        "label": "Company Name",
        "placeholder": "Company name"
      },
      "gender": {
        "label": "Gender",
        "placeholder": "Gender",
        "male": "Male",
        "female": "Female"
      },
      "pec": {
        "label": "PEC",
        "placeholder": "PEC"
      },
      "sdi": {
        "label": "SDI",
        "placeholder": "SDI"
      },
      "phone": {
        "label": "Phone",
        "placeholder": "+39 123456789"
      },
      "height": {
        "label": "Height (cm)",
        "placeholder": "Height (cm)"
      },
      "birthDate": {
        "label": "Date of Birth",
        "placeholder": "Date of birth"
      },
      "birthCity": {
        "label": "City of Birth",
        "placeholder": "City of birth"
      },
      "nationality": {
        "label": "Nationality",
        "placeholder": "Nationality"
      },
      "country": {
        "placeholder": "Country of residence"
      },
      "province": {
        "placeholder": "Province of residence"
      },
      "city": {
        "label": "City",
        "placeholderResidence": "City of residence",
        "placeholderDomicile": "City of domicile"
      },
      "zip": {
        "placeholder": "Postal code"
      },
      "address": {
        "label": "Address",
        "placeholderResidence": "Residence address",
        "placeholderDomicile": "Domicile address"
      },
      "domicileCountry": {
        "placeholder": "Country of domicile"
      },
      "domicileProvince": {
        "placeholder": "Province of domicile"
      },
      "domicileCity": {
        "placeholder": "City of domicile"
      },
      "domicileZip": {
        "placeholder": "Postal code of domicile"
      }
    }
  },
  "editPassword": {
    "title": "Change Password",
    "oldPassword": {
      "label": "Old Password",
      "placeholder": "Your current password"
    },
    "newPassword": {
      "label": "New Password",
      "placeholder": "Your new password"
    },
    "passwordConfirm": {
      "label": "Confirm Password",
      "placeholder": "Repeat your new password"
    },
    "submit": "CONFIRM",
    "successMessage": "Password changed successfully!",
    "validation": {
      "passwordMismatch": "Passwords do not match."
    }
  },
  "bookings": {
    "list": {
      "title": "Bookings",
      "noRecords": "No bookings found",
      "columns": {
        "holiday": "Holiday",
        "bookingDate": "Booking Date",
        "bookingStatus": "Booking Status",
        "holidayStatus": "Holiday Status",
        "paymentStatus": "Payment Status",
        "actions": "",
        "details": "Details"
      },
      "tooltips": {
        "incompleteData": "Incomplete participant data",
        "viewDetails": "View details"
      }
    },
    "detail": {
      "backToList": "Back to List",
      "notFound": "Booking with ID {id} not found",
      "verifying": "We are verifying your booking. Please do not close or reload the page.",
      "canceled": {
        "title": "Booking Canceled",
        "message": "Your booking has been canceled. For more information, please contact us.",
        "contact": "Contact Us"
      },
      "suspended": {
        "title": "Booking Suspended",
        "message": "Your booking is suspended. For more information, please contact us.",
        "contact": "Contact Us"
      },
      "paymentPending": {
        "title": "Payment Pending",
        "message": "Your booking is awaiting payment. To complete the booking, make a payment or contact us for assistance.",
        "depositMessage": "Your booking is awaiting payment of the balance. To complete the booking, make a payment before {{date}}.",
        "completePayment": "Complete Payment"
      },
      "sections": {
        "holidaySummary": "Holiday Summary",
        "documents": "Documents",
        "bookingSummary": "Booking Summary",
        "costSummary": "Cost Summary"
      },
      "fields": {
        "period": "Period",
        "program": "View program",
        "precontract": "Pre-contract",
        "contract": "Contract",
        "departureInfo": "Pre-departure Information",
        "departureInfoByAccommodation": "Departure Information",
        "download": "Download",
        "fillData": "Fill Data",
        "participantData": "Fill data: participant {firstName} {lastName}"
      },
      "costs": {
        "holidayCost": "Holiday Cost",
        "roomCost": "Room Cost",
        "roomWithSupplement": "Room with Supplement",
        "extras": "Extras",
        "insurance": "Insurance",
        "discount": "Discount",
        "total": "TOTAL",
        "deposit": "DEPOSIT",
        "balance": "Balance"
      }
    },
    "participant": {
      "fields": {
        "firstName": {
          "label": "First Name"
        },
        "lastName": {
          "label": "Last Name"
        },
        "email": {
          "label": "Email",
          "placeholder": "email@example.com"
        },
        "taxCode": {
          "label": "Tax Code",
          "placeholder": "Tax Code"
        },
        "phone": {
          "label": "Phone",
          "placeholder": "+39 123456789"
        },
        "height": {
          "label": "Height (cm)",
          "placeholder": "Height (cm)"
        },
        "birthDate": {
          "label": "Date of Birth",
          "placeholder": "Date of birth"
        },
        "birthCity": {
          "label": "City of Birth",
          "placeholder": "City of birth"
        },
        "country": {
          "placeholder": "Country of residence"
        },
        "province": {
          "placeholder": "Province of residence"
        },
        "city": {
          "label": "City",
          "placeholder": "City of residence"
        },
        "zip": {
          "placeholder": "Postal code"
        },
        "address": {
          "label": "Address",
          "placeholder": "Residence address"
        },
        "notes": {
          "label": "Notes / Allergies / Other Information",
          "placeholder": "Notes / Allergies / Other Information"
        }
      },
      "info": {
        "taxCode": "Tax Code",
        "gender": "Gender",
        "birthDate": "Date of Birth",
        "birthCity": "City of Birth",
        "height": "Height",
        "phone": "Phone",
        "country": "Country",
        "province": "Province",
        "city": "City",
        "zip": "Postal Code",
        "address": "Address",
        "notes": "Notes / Allergies / Other Information",
        "room": "Room",
        "holidayCost": "Holiday Cost",
        "roomWithSupplement": "Room with Supplement",
        "extras": "Extras",
        "insurance": "Insurance",
        "discount": "Discount",
        "total": "TOTAL",
        "genderMale": "Male",
        "genderFemale": "Female",
        "heightUnit": "cm",
        "ensuranceNumber": "Insurance Policy Number"
      },
      "actions": {
        "cancel": "Cancel",
        "confirm": "Confirm"
      }
    }
  },
  "wishlist": {
    "title": "Wishlist",
    "empty": "Wishlist is empty",
    "card": {
      "perPerson": "Per Person",
      "discover": "DISCOVER",
      "remove": {
        "title": "Remove Holiday",
        "message": "You are about to remove the holiday from your wishlist. \nContinue?",
        "confirm": "Confirm",
        "cancel": "Cancel"
      }
    }
  },
  "common": {
    "buttons": {
      "confirm": "Confirm",
      "cancel": "Cancel",
      "submit": "Submit",
      "update": "Update",
      "save": "Save",
      "delete": "Delete",
      "edit": "Edit",
      "close": "Close",
      "back": "Back",
      "next": "Next",
      "download": "Download",
      "contact": "Contact Us"
    },
    "validation": {
      "required": "Required field",
      "invalidEmail": "Invalid email",
      "passwordMismatch": "Passwords do not match",
      "emailMismatch": "Emails do not match",
      "unexpectedError": "Unexpected error. Please try again later."
    },
    "pagination": {
      "itemsPerPage": "Items per page"
    },
    "passwordRequirements": {
      "minLength": "Must contain at least 6 characters",
      "number": "Must contain at least one number",
      "lowercase": "Must contain at least one lowercase letter",
      "uppercase": "Must contain at least one uppercase letter",
      "special": "Must contain at least one special character"
    }
  },
  "rooms": {
    "types": {
      "single": "Single",
      "double": "Double",
      "triple": "Triple",
      "quadruple": "Quadruple",
      "doubleSingleUse": "Double Single Use",
      "doubleMatrimonial": "Double Matrimonial",
      "doubleBunk": "Double (Bunk)",
      "dinette": "Dinette",
      "berth": "Berth",
      "dormitory": "Dormitory"
    },
    "variants": {
      "superior": "superior",
      "deluxe": "deluxe",
      "sharedBathroom": "(shared bathroom)",
      "privateBathroom": "(private bathroom)"
    },
    "shared": {
      "shared": "shared",
      "male": "(male)",
      "female": "(female)",
      "info": "Room shared with participants of the same gender"
    }
  },
  "status": {
    "booking": {
      "confirmed": {
        "label": "Confirmed",
        "tooltip": "Booking confirmed"
      },
      "canceled": {
        "label": "Canceled",
        "tooltip": "Booking canceled"
      },
      "pending": {
        "label": "Pending",
        "tooltip": "Booking pending"
      },
      "suspended": {
        "label": "Suspended",
        "tooltip": "Booking suspended"
      },
      "unavailable": {
        "label": "Unavailable",
        "tooltip": "Unavailable"
      }
    },
    "payment": {
      "paid": {
        "label": "Paid",
        "tooltip": "Payment confirmed"
      },
      "pendingBalance": {
        "label": "Pending Balance",
        "tooltip": "Payment pending balance"
      },
      "failed": {
        "label": "Failed",
        "tooltip": "Payment failed"
      },
      "pending": {
        "label": "Pending",
        "tooltip": "Payment pending"
      },
      "notRequired": {
        "label": "Not required",
        "tooltip": "No payment is required for this booking"
      }
    },
    "holiday": {
      "confirmed": {
        "label": "Confirmed",
        "tooltip": "Holiday confirmed"
      },
      "pending": {
        "label": "Pending Confirmation",
        "tooltip": "Holiday pending confirmation"
      },
      "unavailable": {
        "label": "Unavailable",
        "tooltip": "Holiday unavailable"
      }
    }
  }
}
